$shm_hitalama_map_widget_float_table_column $mol_view
	table $shm_hitalama_map_widget_float_table
	column -1
	expanded? false
	attr *
		^
		shm_hitalama_map_widget_float_table_column_expanded <= expanded
	sub <= panel_content /
		<= Head $mol_view
			sub /
				<= Title $mol_view
					sub / <= title \
				^ collapse_visible /
					<= Collapse $mol_button_minor
						title \Свернуть
						click? <=> collapse? null
				<= Close $mol_button_minor
					title \Закрыть
					click? <=> close? null
		<= Body $mol_scroll
			sub /
				<= Content $mol_list
					sub /
						<= Name_label $mol_labeler
							title \Название
							Content <= Name $shm_hitalama_map_widget_float_table_col_name
								value? <=> name? \
								commit? <=> name_commit? null
						<= Width_label $mol_labeler
							title \Ширина, px
							Content <= Width $mol_number
								value? <=> width? NaN
								hint \auto
								Dec null
								Inc null
						<= Type_label $mol_labeler
							title \Тип
							Content <= Type $mol_select
								value? <=> type? \any
								dictionary <= type_options *
								Filter null
						^ code_visible /
							<= Code_label $mol_labeler
								title \Код отображения
								label /
									\Код отображения
									<= Expand $mol_button_minor
										hint \Отредактировать код
										click? <=> expand? null
										sub / <= Expand_icon $mol_icon_code_braces
								Content <= Code_scroll $mol_scroll
									sub /
										<= Code $mol_textarea
											value? <=> code? \
											sidebar_showed true
							<= Help $mol_view
								sub / <= help \
